import { useRepository } from 'hooks/auth'
import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'
import { useCheckCommitFileVersion } from './useCheckCommitFileVersion'
import { InlineDialog } from 'components/dialogs/Dialog'
import { BreakoutButton } from 'components/design-system/BreakoutButton'
import { useRootStore } from 'hooks/rootStore'
import { inLocalDev } from 'config/environment'

export const SchemaErrorNeedsUpdate = observer(
  function SchemaErrorNeedsUpdate() {
    const repository = useRepository()
    const rootStore = useRootStore()

    // NEVER mount this on update page itself
    if (rootStore.router.currentRoute?.title === 'guidedUpdate') return

    if (!repository.hasZodError) return null

    return <SchemaErrorNeedsUpdateNested />
  }
)

function SchemaErrorNeedsUpdateNested() {
  const { isOutdatedVersion } = useCheckCommitFileVersion()
  const { tt } = useTranslationTyped()
  const headerId = 'schema-error-needs-update-heading'

  if (!isOutdatedVersion && !inLocalDev()) return null

  return (
    <InlineDialog
      aria-labelledby={headerId}
      size="sm"
      innerClassName="flex flex-col justify-between items-center text-center"
    >
      <h1 className="text-headline-medium" id={headerId}>
        {tt.errors.zod_error_header()}
      </h1>
      <div className="mt-4 whitespace-pre-wrap">
        {tt.errors.zod_error_message()}
      </div>
      <BreakoutButton
        kind="accent"
        className="mt-6"
        onClick={() => {
          const loc = window.location
          const path = loc.pathname + loc.search
          window.location.href = '/update?returnTo=' + encodeURIComponent(path)
        }}
      >
        {tt.errors.zod_error_update_button()}
      </BreakoutButton>
    </InlineDialog>
  )
}
